<template>
  <div class="p-4">
    <h6 class="mb-base">{{ $t('orgDashboard.settingsHelp.frequentlyAskedQuestions') }}</h6>
    <vs-collapse accordion type="shadow">
      <vs-collapse-item>
        <div slot="header">{{ $t('orgDashboard.settingsHelp.question1') }}</div>
        {{ $t('orgDashboard.settingsHelp.helpText') }}
      </vs-collapse-item>

      <vs-collapse-item>
        <div slot="header">{{ $t('orgDashboard.settingsHelp.question2') }}</div>
        {{ $t('orgDashboard.settingsHelp.helpText') }}
      </vs-collapse-item>

      <vs-collapse-item>
        <div slot="header">{{ $t('orgDashboard.settingsHelp.question3') }}</div>
        {{ $t('orgDashboard.settingsHelp.helpText') }}
      </vs-collapse-item>

      <vs-collapse-item>
        <div slot="header">{{ $t('orgDashboard.settingsHelp.question4') }}</div>
        {{ $t('orgDashboard.settingsHelp.helpText') }}
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
    };
  },
};
</script>

<style scoped>
</style>
